import { Window } from '@execonline-inc/browser-window.private';
import { CheckIcon, emptyFragment, MenuItem, Typography } from '@execonline-inc/execonline-ui';
import { when } from '@execonline-inc/maybe-adapter';
import { identity } from '@kofno/piper';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import { useTranslationsContext } from '../../../../../../Translations/UseTranslationsContext';
import { WaffleIconListItem } from '../../../../../Dropdown/Types';
import { NavigationMenuItemProps } from '../Types';

function ApplicationMenuItem({ item }: NavigationMenuItemProps<WaffleIconListItem>) {
  const { id, href, icon, name, check } = item;
  const { translate } = useTranslationsContext();

  const handleMenuItemClick = (href: string) => (e: React.KeyboardEvent | React.MouseEvent) => {
    when(check, item)
      .do(() => e.preventDefault())
      .elseDo(() => {
        Window.openWindow(href, '_self', { noopener: just(true), noreferrer: just(true) });
      });
  };

  return (
    <MenuItem
      data-testid={`application-menu_${id}-menu-item`}
      className="items-center hover:text-teal-600"
      aria-label={translate(name)}
      startContent={icon}
      endContent={when(identity, check)
        .map(() => <CheckIcon color="teal" />)
        .getOrElse(emptyFragment)}
      onClick={handleMenuItemClick(href)}
    >
      <Typography
        data-testid={name}
        color="inherit"
        fontWeight="semibold"
        variant="subtitleMedium"
        as="span"
      >
        <T kind={name} />
      </Typography>
    </MenuItem>
  );
}

export default observer(ApplicationMenuItem);
